import * as React from "react";
import type { SVGProps } from "react";
const SvgJcb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#fff"
      d="M22 16.298a3.11 3.11 0 0 1-3.105 3.105H2V7.105A3.11 3.11 0 0 1 5.105 4H22z"
    />
    <path
      fill="url(#jcb_svg__a)"
      d="M16.499 13.144h1.283c.037 0 .123-.012.16-.012a.57.57 0 0 0 .452-.575.59.59 0 0 0-.453-.574c-.036-.012-.11-.012-.159-.012H16.5z"
    />
    <path
      fill="url(#jcb_svg__b)"
      d="M17.636 5.04c-1.223 0-2.225.99-2.225 2.224v2.31h3.142c.073 0 .159 0 .22.013.709.036 1.234.403 1.234 1.039 0 .501-.354.929-1.014 1.015v.024c.72.049 1.271.452 1.271 1.076 0 .672-.611 1.112-1.418 1.112h-3.447v4.524h3.264c1.222 0 2.224-.99 2.224-2.225V5.039z"
    />
    <path
      fill="url(#jcb_svg__c)"
      d="M18.235 10.773a.52.52 0 0 0-.453-.526c-.024 0-.085-.012-.122-.012H16.5v1.076h1.161c.037 0 .11 0 .122-.013a.52.52 0 0 0 .453-.525"
    />
    <path
      fill="url(#jcb_svg__d)"
      d="M11.487 5.04c-1.223 0-2.225.99-2.225 2.224v2.91c.562-.477 1.54-.783 3.117-.71.844.037 1.748.27 1.748.27v.94a4.2 4.2 0 0 0-1.687-.488c-1.198-.086-1.92.501-1.92 1.528 0 1.04.722 1.626 1.92 1.528.697-.049 1.235-.269 1.687-.489v.941s-.892.233-1.748.27c-1.577.073-2.555-.233-3.117-.71v5.135h3.264c1.222 0 2.225-.99 2.225-2.225V5.039z"
    />
    <path
      fill="url(#jcb_svg__e)"
      d="M5.337 5.04c-1.222 0-2.225.99-2.225 2.224v5.49c.624.305 1.272.5 1.92.5.77 0 1.186-.464 1.186-1.1V9.562h1.907v2.58c0 1.002-.624 1.821-2.739 1.821a9.4 9.4 0 0 1-2.286-.28v4.681h3.264c1.223 0 2.225-.99 2.225-2.225V5.04z"
    />
    <defs>
      <linearGradient
        id="jcb_svg__a"
        x1={15.409}
        x2={20.902}
        y1={12.559}
        y2={12.559}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset={0.229} stopColor="#00873f" />
        <stop offset={0.743} stopColor="#40a737" />
        <stop offset={1} stopColor="#5cb531" />
      </linearGradient>
      <linearGradient
        id="jcb_svg__b"
        x1={15.409}
        x2={20.902}
        y1={11.703}
        y2={11.703}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset={0.229} stopColor="#00873f" />
        <stop offset={0.743} stopColor="#40a737" />
        <stop offset={1} stopColor="#5cb531" />
      </linearGradient>
      <linearGradient
        id="jcb_svg__c"
        x1={15.409}
        x2={20.902}
        y1={10.771}
        y2={10.771}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset={0.229} stopColor="#00873f" />
        <stop offset={0.743} stopColor="#40a737" />
        <stop offset={1} stopColor="#5cb531" />
      </linearGradient>
      <linearGradient
        id="jcb_svg__d"
        x1={9.23}
        x2={14.648}
        y1={11.703}
        y2={11.703}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6c2c2f" />
        <stop offset={0.173} stopColor="#882730" />
        <stop offset={0.573} stopColor="#be1833" />
        <stop offset={0.859} stopColor="#dc0436" />
        <stop offset={1} stopColor="#e60039" />
      </linearGradient>
      <linearGradient
        id="jcb_svg__e"
        x1={3.11}
        x2={8.688}
        y1={11.703}
        y2={11.703}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1f286f" />
        <stop offset={0.475} stopColor="#004e94" />
        <stop offset={0.826} stopColor="#0066b1" />
        <stop offset={1} stopColor="#006fbc" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgJcb;
